import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';

/**
 * Firebase web config.
 * Defaults to the Tent Finder production project.
 * Override any value with REACT_APP_FIREBASE_* env vars if needed.
 */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCIjtCQE3QAoWdssBj0BbfoDEjZC1_Yx2A',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'thetentfinder.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'thetentfinder',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'thetentfinder.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '280637060974',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:280637060974:web:1885bdfd639e70f42e737f',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Enable offline data persistence for mobile outreach resilience
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Firestore offline persistence disabled: multiple tabs open.');
    } else if (err.code === 'unimplemented') {
      console.warn('Firestore offline persistence is not supported in this browser.');
    }
  });
}

export default app;
